
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Posting } from "@/generated/graphql";

import PageHeadContainer from "@/components/page/PageHeadContainer.vue";
import PageHeadIcon from "@/components/page/PageHeadIcon.vue";
import LocationIcon from "@/components/icons/LocationIcon.vue";
import UserIcon from "@/components/icons/UserIcon.vue";
import TimerIcon from "@/components/icons/TimerIcon.vue";
import ClockIcon from "@/components/icons/ClockIcon.vue";
import TrashIcon from "@/components/icons/TrashIcon.vue";
import EditIcon from "@/components/icons/EditIconNew.vue";
import UiButton from "@/components/button/ui-button.vue";
import PostingModal from "@/components/postings/PostingModalV2.vue";
import PostingActivenessToggleButton from "@/components/recruitings/PostingActivenessToggleButton.vue";
import getLocationInfo from "@/helpers/locations/getLocationInfo";
import PencilIcon from "../icons/Pencil-Icon.vue";
import CompleteIcon from "@/components/icons/Checkmark.vue";
import CheckMarkBlack from "@/components/icons/CheckMarkBlack.vue";
import SwitchComponent from "../Switch/Switch.vue";
import UPDATE_POSTING_ACTIVE_STATUS from "@/apollo/jobboard/UpdatePostingActiveStatus.gql";
import ItemChip from "@/components/common/ItemChip.vue";
import RouteNames from "@/entities/RouteNames";
import { getPostedAt } from "@/helpers/postings/getPostedAtLabel";
import { formatCurrency } from "@/utils";

@Component({
  components: {
    PageHeadContainer,
    PageHeadIcon,
    LocationIcon,
    CompleteIcon,
    TrashIcon,
    TimerIcon,
    CheckMarkBlack,
    ClockIcon,
    UserIcon,
    UiButton,
    EditIcon,
    PostingModal,
    PostingActivenessToggleButton,
    PencilIcon,
    SwitchComponent,
    ItemChip,
  },
})
export default class PostingHeader extends Vue {
  @Prop({ type: Object, required: true }) readonly posting!: Posting;
  @Prop({ type: String, default: undefined }) readonly managerId!: string;
  @Prop({ type: String, required: true }) readonly companyId!: string;
  @Prop({ type: Boolean, required: false }) readonly isManager!: boolean;
  routes = RouteNames;
  dialog: boolean = false;
  get getBudet(): string {
    let budget = "n/a";
    const minrate =this.posting.min_rate;
    const maxrate = this.posting.max_rate;
    if (minrate != null) {
      const isDecimal = `${minrate}`.match(/\./g);
      budget = formatCurrency(minrate, { precision: isDecimal ? 2: 0 });
    }
    if (maxrate != null) {
      const isDecimal = `${maxrate}`.match(/\./g);
      budget += `- ${formatCurrency(maxrate, { precision: isDecimal ? 2: 0 })}`;
    }
    return budget;
  }
  get postedAt(): string[] {
    return getPostedAt(this.posting.public);
  }
  get jobDuration(): string | undefined {
    const { duration } = this.posting;
    if (!duration) {
      return undefined;
    }

    const weeks = Math.floor(duration / 7);
    const days = duration % 7;

    const weeksVal = this.formatDateItem("week", weeks);
    const daysVal = this.formatDateItem("day", days);

    return `${weeksVal} ${daysVal}`;
  }

  // get manager(): string | undefined {
  //   const user = this.posting.manager?.user;
  //   if (!user) {
  //     return undefined;
  //   }

  //   return `${user.given_name} ${user.family_name}`;
  // }
  get manager(): any {
    const user = this.posting.manager?.user;
    if (!user) {
      return undefined;
    }

    return {
      name: `${user.given_name} ${user.family_name}`,
      id: this.posting.manager!.id,
      avatar: user.avatar,
    };
  }
  get location(): string {
    return getLocationInfo(this.posting, true);
  }
  updateCrumb() {
    const breadcrubmData = document.querySelector(
      ".site_breadcumb_ul li:nth-child(3) > span"
    );
    if (breadcrubmData) {
      breadcrubmData.innerHTML = `${this.posting.job_title}`;
    }
  }
  @Watch("posting")
  crumbdata() {
    this.updateCrumb();
  }
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange() {
    this.updateCrumb();
  }

  formatDateItem(unitName: string, value: number): string {
    if (!value) {
      return "";
    }
    if (value !== 1) {
      unitName += "s";
    }

    return `${value} ${unitName}`;
  }
  async handleToggleActiveness(isActive): Promise<any> {
    try {
      this.posting.active = isActive;
      const resp = await this.$apollo.mutate({
        mutation: UPDATE_POSTING_ACTIVE_STATUS,
        variables: {
          id: this.posting.id,
          set: { active: isActive },
        },
      });
      const postingData = resp.data?.update_posting_by_pk;
      if (postingData) {
        this.posting.active = postingData.active;
      }
      return resp;
    } catch (error) {
      this.posting.active = !isActive;
      return false;
    }
  }
  get managerRouteName(): string | undefined {
    return this.isManager
      ? undefined /* If the RouteName is undefined, the manager chip will be inactive */
      : this.routes.MANAGER_ABOUT;
  }
  get getActiveTitle() {
    return this.posting.active ? "Deactivate" : "Activate";
  }
}
